/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} More_OptionsInputs */

const en_more_options = /** @type {(inputs: More_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`More Options`)
};

const fr_more_options = /** @type {(inputs: More_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus d’options`)
};

const de_more_options = /** @type {(inputs: More_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weitere Optionen`)
};

const it_more_options = /** @type {(inputs: More_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Altre opzioni`)
};

const ru_more_options = /** @type {(inputs: More_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Дополнительные варианты`)
};

const es_more_options = /** @type {(inputs: More_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Más opciones`)
};

const zh_cn2_more_options = /** @type {(inputs: More_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`更多选项`)
};

const ja_more_options = /** @type {(inputs: More_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`その他のオプション`)
};

const hi_more_options = /** @type {(inputs: More_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अधिक विकल्प`)
};

const pt_pt2_more_options = /** @type {(inputs: More_OptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mais opções`)
};

/**
* | output |
* | --- |
* | "More Options" |
*
* @param {More_OptionsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const more_options = /** @type {((inputs?: More_OptionsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<More_OptionsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_more_options(inputs)
	if (locale === "de") return de_more_options(inputs)
	if (locale === "it") return it_more_options(inputs)
	if (locale === "ru") return ru_more_options(inputs)
	if (locale === "es") return es_more_options(inputs)
	if (locale === "zh-CN") return zh_cn2_more_options(inputs)
	if (locale === "ja") return ja_more_options(inputs)
	if (locale === "hi") return hi_more_options(inputs)
	if (locale === "pt-PT") return pt_pt2_more_options(inputs)
	return en_more_options(inputs)
});